import React from "react";
import { Card, Typography } from "antd";

const { Title, Paragraph, Text } = Typography;

export default function Privacy() {
  return (
    <div className="bv-page">
      <div className="bv-container">
        <Card className="bv-card" bordered={false}>
          <Title level={2} className="bv-title">Política de Privacidade</Title>

          <Paragraph style={{ color: "rgba(255,255,255,0.92)" }}>
            A Óticas Bluevision respeita sua privacidade. Esta página explica como tratamos os dados
            coletados neste site/quiz.
          </Paragraph>

          <Title level={4} style={{ color: "#fff" }}>Quais dados coletamos</Title>
          <Paragraph style={{ color: "rgba(255,255,255,0.92)" }}>
            Coletamos <Text strong>apenas o primeiro nome</Text> informado por você no quiz, além de
            informações não identificáveis sobre as escolhas do quiz (ex.: objetivo, interesse).
          </Paragraph>

          <Title level={4} style={{ color: "#fff" }}>Finalidade</Title>
          <Paragraph style={{ color: "rgba(255,255,255,0.92)" }}>
            Usamos as informações para melhorar sua experiência e direcionar seu atendimento para a unidade
            mais próxima, inclusive via WhatsApp quando você optar por entrar em contato.
          </Paragraph>

          <Title level={4} style={{ color: "#fff" }}>Medição e anúncios</Title>
          <Paragraph style={{ color: "rgba(255,255,255,0.92)" }}>
            Podemos utilizar ferramentas de medição (ex.: Google Tag Manager) para entender o desempenho do site.
            <Text strong> Não enviamos dados pessoais</Text> (como nome) para plataformas de anúncios/medição.
          </Paragraph>

          <Title level={4} style={{ color: "#fff" }}>Cookies</Title>
          <Paragraph style={{ color: "rgba(255,255,255,0.92)" }}>
            Podemos usar cookies/tecnologias semelhantes para funcionamento e análise. Você pode gerenciar cookies
            no seu navegador.
          </Paragraph>

          <Title level={4} style={{ color: "#fff" }}>Contato</Title>
          <Paragraph style={{ color: "rgba(255,255,255,0.92)" }}>
            Em caso de dúvidas, fale com a equipe pelo WhatsApp na unidade escolhida.
          </Paragraph>
        </Card>
      </div>
    </div>
  );
}
